var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 242,
    viewBox: "0 0 220 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z",
    fill: "#53CFD7",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.68 241.48C145.954 241.48 175.36 240.253 175.36 238.74C175.36 237.227 145.954 236 109.68 236C73.4059 236 44 237.227 44 238.74C44 240.253 73.4059 241.48 109.68 241.48Z",
    fill: "#53CFD7",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.041 88.1008L188.008 113.051L187.252 117.84C187.252 121.548 179.331 170.369 175.227 170.369L110.348 125.545L38.3772 175.482C34.2728 175.482 29.9524 122.952 29.9524 119.244L29.6643 113.051L28.5122 88.1728L40.1054 78.1638L105.74 21.4581C108.44 19.514 112.293 19.514 114.993 21.4581L180.555 78.1638L192.041 88.1008Z",
    fill: "#228991"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.898 87.9561V164.248H59.2954V65.9219H138.647L160.898 87.9561Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.898 87.9567V90.5129H136.091V65.8145L138.648 65.9225L160.898 87.9567Z",
    fill: "#228991"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.898 87.9561H138.647V65.9219L160.898 87.9561Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.933 140.09L149.124 102.142C158.881 92.169 172.851 86.4805 187.468 86.4805C190.889 86.4805 193.697 88.7487 193.697 91.521V143.222V192.943C193.697 195.751 189.052 199.964 185.596 199.964H164.462L111.897 146.354C110.168 144.626 110.168 141.89 111.933 140.09Z",
    fill: "#30C4CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.764 140.055L71.5725 102.107C61.8155 92.1339 47.8821 86.4453 33.2286 86.4453C29.8083 86.4453 27 88.7135 27 91.4858V143.187V193.52C27 196.328 30.9964 200.001 34.4167 200.001L56.1989 199.929L108.764 146.319C110.528 144.555 110.528 141.819 108.764 140.055Z",
    fill: "#30C4CF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.697 172.205V194.095C193.697 197.371 190.384 200 186.28 200H34.4167C30.3123 200 27 197.335 27 194.095V172.205L105.74 122.232C107.036 121.404 108.548 120.972 110.096 120.936C111.824 120.9 113.553 121.332 114.993 122.232L193.697 172.205Z",
    fill: "#53CFD7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27 163.097L95.5149 126.518L96.847 127.886L27 172.206V163.097Z",
    fill: "#228991"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M193.697 163.097L125.218 126.518L123.85 127.886L193.697 172.206V163.097Z",
    fill: "#228991"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.096 98.1816C102.139 98.1816 95.6587 104.662 95.6587 112.619H124.534C124.534 104.626 118.053 98.1816 110.096 98.1816Z",
    fill: "#98E2E7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.096 97.0656C114.212 97.0656 117.549 93.7289 117.549 89.6129C117.549 85.4969 114.212 82.1602 110.096 82.1602C105.98 82.1602 102.643 85.4969 102.643 89.6129C102.643 93.7289 105.98 97.0656 110.096 97.0656Z",
    fill: "#98E2E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f5e641217ffd94e3a7de8adcab4ffaaf.svg";
export { ForwardRef as ReactComponent };